(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vr-meters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountedCharts = new Map();
    const normalizeHeading = text => text.normalize('NFKC').replace(/[\s◾▪■️]/gu, '').toLowerCase();
    const headingPairs = [
      ['商品詳細', '利用シーン適性'],
      ['Product Details', 'Suitability by Occasion'],
      ['상품 상세', '착용 추천 상황'],
      ['商品資訊', '適用場合']
    ].map(pair => pair.map(normalizeHeading));
    const placeCharts = () => {
      for (const [chart, home] of mountedCharts) {
        if (!chart.isConnected || !home.isConnected) mountedCharts.delete(chart);
      }
      document.querySelectorAll('.vr-meter-section[data-vr-product-id]').forEach(chart => {
        const productId = chart.dataset.vrProductId;
        const productRoot = Array.from(document.querySelectorAll('[id^="ProductSection-"]')).find(root => root.id.endsWith('-' + productId));
        if (!productRoot) return;
        let destination;
        for (const description of productRoot.querySelectorAll('.rte')) {
          const children = Array.from(description.children);
          const headings = children.map(node => normalizeHeading(node.textContent));
          for (const [detailsHeading, scenesHeading] of headingPairs) {
            const detailsIndex = headings.indexOf(detailsHeading);
            const scenesIndex = headings.indexOf(scenesHeading);
            if (detailsIndex >= 0 && scenesIndex > detailsIndex) {
              destination = children[scenesIndex];
              break;
            }
          }
          if (destination) break;
        }
        if (!destination) return;
        const home = mountedCharts.get(chart) || chart.closest('.shopify-section');
        if (!home) return;
        mountedCharts.set(chart, home);
        chart.classList.add('vr-meter-section--inline');
        if (chart.nextElementSibling !== destination) destination.before(chart);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeCharts, { once: true });
    } else {
      placeCharts();
    }
    document.addEventListener('shopify:section:load', placeCharts);
    document.addEventListener('shopify:section:unload', event => {
      for (const [chart, home] of mountedCharts) {
        if (event.target === home || event.target.contains(home)) {
          chart.remove();
          mountedCharts.delete(chart);
        } else if (event.target.contains(chart)) {
          home.append(chart);
          chart.classList.remove('vr-meter-section--inline');
        }
      }
    });
    document.addEventListener('shopify:section:select', event => {
      for (const [chart, home] of mountedCharts) {
        if (event.target === home && chart.isConnected) chart.scrollIntoView({ block: 'center' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
